<template>
  <div id="`psnpayrolllist`">
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>


<script>
import GridView from "../../../components/common/GridView";
import moment from "moment";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('maintenanceforpayroll.personpayrollinstructionlist'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "80px" },
        { text: this.$t('columns.staffcode'), value: "staffcode", width: "100px" },
        { text: this.$t('columns.name'), value: "psnname", width: "200px" },
        { text: this.$t('columns.startdate'), value: "startdate", width: "200px" },
        { text: this.$t('columns.enddate'), value: "enddate", width: "200px" },
        { text: this.$t('maintenanceforpayroll.paymentmode'), value: "paymodecode", width: "200px" },
        { text: this.$t('maintenanceforpayroll.paymentstatus'), value: "pystatcode", width: "200px",},
        { text: this.$t('maintenanceforpayroll.taxcategory'), value: "pcbcatcode", width: "200px" },
        { text: this.$t('maintenanceforpayroll.epf'), value: "epfgroupcode", width: "200px" },
        { text: this.$t('maintenanceforpayroll.socso'), value: "socsocode", width: "200px" },
        { text: this.$t('setupepfve.epfve'), value: "epfvecode", width: "200px" },
        { text: this.$t('maintenanceforpayroll.eis'), value: "isEis", width: "200px" },
        { text: this.$t('maintenanceforpayroll.baitulmal'), value: "baitulmalcode", width: "200px" },
        { text: this.$t('maintenanceforpayroll.dynamiczakat'), value: "isdynamic", width: "200px" },
        { text: this.$t('maintenanceforpayroll.zakatpercentage'), value: "zakatp", width: "200px" },
        // { text: "ZAKAT AMOUNT", value: "zakatamt", width: "200px" }
      ],

      dataItems: [],
      loading: false,
      errMsg: "",
      search: this.$route.params.search,
    };
  },

  methods: {
    //Handler for getting the records
    getPersonPayrollListHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: `/psnpayroll/all/${this.$store.getters.userId}`})
        .then(function (res) {
          vm.dataItems = res.data.rec;

          for (let i = 0; i < vm.dataItems.length; i++) {
            if (vm.dataItems[i].startdate) {
              vm.dataItems[i].startdate = moment(
                vm.dataItems[i].startdate
              ).format("YYYY-MM-DD");
            }

            if (vm.dataItems[i].enddate) {
              vm.dataItems[i].enddate = moment(vm.dataItems[i].enddate).format(
                "YYYY-MM-DD"
              );
            }
          }

          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "psnpayrolledit", params: { id: item.id, search: item.search } });
    },

    newRecordHandler() {
      this.$router.push({ name: "psnpayrollnew" });
    },
  },

  mounted() {
    this.getPersonPayrollListHandler();
  },
};
</script>

                